<template>
  <div class="customer-tab">
    <table
      v-if="points.length"
      class="table is-bordered is-striped is-marginless is-fullwidth "
    >
      <thead>
        <tr>
          <th class="has-text-centered">Πόντοι</th>
          <th class="has-text-centered">Περιγραφή</th>
          <th class="has-text-centered">Τύπος</th>
          <th class="has-text-centered">Ημ/νία Δημιουργίας</th>
          <th class="has-text-centered">Ημ/νία Λήξης</th>
        </tr>
      </thead>
      <tbody>
        <item v-for="item in points" :item="item" :key="item.id" />
      </tbody>
    </table>
    <h5 v-else class="title is-5 has-text-centered is-marginless">
      Δε βρέθηκαν loyalty points
    </h5>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import _get from 'lodash/get';
import Item from './components/Loyalty';

export default {
  components: {
    Item,
  },
  computed: {
    ...mapGetters({
      customer: 'customers/edit/getCustomer',
    }),
    points() {
      return _get(this.customer, 'profile.points', []);
    },
  },
};
</script>
